var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("container-item-wrapper", { attrs: { widget: _vm.widget } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.widget.options.hidden,
            expression: "!widget.options.hidden",
          },
        ],
        key: _vm.widget.id,
        staticClass: "table-container",
      },
      [
        _c(
          "table",
          {
            ref: _vm.widget.id,
            staticClass: "table-layout",
            class: [_vm.customClass],
          },
          [
            _c(
              "tbody",
              _vm._l(_vm.widget.rows, function (row, rowIdx) {
                return _c(
                  "tr",
                  { key: row.id },
                  [
                    _vm._l(row.cols, function (colWidget, colIdx) {
                      return [
                        !colWidget.merged
                          ? _c("table-cell-item", {
                              key: colIdx,
                              attrs: {
                                widget: colWidget,
                                "parent-list": _vm.widget.cols,
                                "row-index": rowIdx,
                                "col-index": colIdx,
                                "parent-widget": _vm.widget,
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm._l(
                                    Object.keys(_vm.$scopedSlots),
                                    function (slot) {
                                      return {
                                        key: slot,
                                        fn: function (scope) {
                                          return [
                                            _vm._t(slot, null, null, scope),
                                          ]
                                        },
                                      }
                                    }
                                  ),
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }